

































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";

@Component({})
export default class CartAction extends Vue {
    public name = "CartAction";

    @Prop({ type: Boolean, default: true })
    public showCheckout!: boolean;

    @Prop({ type: Boolean })
    public disableProceedToCheckout!: boolean;

    @Prop({ type: Object })
    public vm!: CheckoutReviewViewModel;

    public get mobile() {
        return !this.$vuetify.breakpoint.smAndUp;
    }
}
